export const isDevelopment = import.meta.env.MODE === "development"
